import { apiGateway } from "@/_old/services/api-gateway";

export type HomeProfileApiResponse = {
  profile: string;
  confidence: number;
  source: "gold" | "default";
  interactions_90d: number;
  top_intents: string[];
  computed_at: string;
};

/**
 * Endpoint GET /company/agent-profile (atividades 01-03 do plano agent-first),
 * no ar em py-insights-api + api-gateway.
 */
export async function getHomeProfile(): Promise<HomeProfileApiResponse> {
  const { data } = await apiGateway.get<HomeProfileApiResponse>(
    "/company/agent-profile",
  );
  return data;
}
